













































import Vue from 'vue'
import HeaderImage from '@/components/Google/SelectedMarker/HeaderImage.vue'
import InformationPane from '@/components/DebugMap/InformationPane.vue'
import DebugTab from '@/components/DebugMap/DebugTab.vue'
import TripsTab from '@/components/DebugMap/TripsTab.vue'

export default Vue.extend({
  name: 'MapDebugDrawer',
  components: { InformationPane, HeaderImage, TripsTab, DebugTab },
  props: {
    entity: Object,
    marker: Object,
    isActive: Boolean,
    noPastLocation: Boolean
  },
  data () {
    return {
      tab: 'debug'
    }
  },
  methods: {
    updateHandler (update: { position: { lat: number, lng: number }, positionedAt: string }) {
      this.$emit('locationUpdate', update)
      if (!this.$refs.informationPane) return
      const { setAddress, setActivity } = this.$refs.informationPane

      const { lat, lng } = update.position
      setAddress({ latitude: lat, longitude: lng })
      setActivity(update.positionedAt)
    }
  },
  watch: {
    tab(val) {
      if (val !== 'trips') {
        this.$emit('clearRenderedTrip')
      }
    }
  }
})
